/**
 * @generated SignedSource<<8f95e5fe05c419808adfecd23bd44536>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ServicesWithCredits = "AI_STUDIO" | "AI_STUDIO_3D_MODEL_GENERATOR" | "AI_STUDIO_AD_GENERATOR" | "AI_STUDIO_MAGIC_SWAP" | "AI_STUDIO_MULTI_IMAGE_FUSION" | "AI_STUDIO_PRODUCT_STAGING" | "AI_STUDIO_UPSCALER" | "AI_STUDIO_VIDEO_GENERATOR" | "AI_STUDIO_VTO" | "GENERATIVE_AI" | "GENERATIVE_AI_DESIGN" | "GENERATIVE_AI_IMAGE_GENERATOR" | "GENERATIVE_AI_PRODUCT_STAGING" | "GENERATIVE_AI_VTO" | "TEST_ORDERS" | "VECTORIZE";
export type serviceCreditsQuery$variables = {
  addonKey: string;
  baseCurrencyCode: string;
  currencyCode: string;
  serviceName: ServicesWithCredits;
};
export type serviceCreditsQuery$data = {
  readonly exchangeRates: {
    readonly baseCurrency: string | null;
    readonly rates: ReadonlyArray<{
      readonly code: string | null;
      readonly currencyID: number;
      readonly rate: number;
      readonly symbol: string | null;
      readonly zeroDecimal: boolean;
    } | null> | null;
  };
  readonly " $fragmentSpreads": FragmentRefs<"serviceCreditsAddon_fragment" | "serviceCreditsServiceCredit_fragment">;
};
export type serviceCreditsQuery = {
  response: serviceCreditsQuery$data;
  variables: serviceCreditsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "addonKey"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "baseCurrencyCode"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "currencyCode"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "serviceName"
},
v4 = [
  {
    "kind": "Variable",
    "name": "serviceName",
    "variableName": "serviceName"
  }
],
v5 = [
  {
    "kind": "Variable",
    "name": "addonKey",
    "variableName": "addonKey"
  },
  {
    "kind": "Variable",
    "name": "currencyCode",
    "variableName": "currencyCode"
  }
],
v6 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "baseCurrencyCode",
      "variableName": "baseCurrencyCode"
    }
  ],
  "concreteType": "ExchangeRates",
  "kind": "LinkedField",
  "name": "exchangeRates",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "baseCurrency",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ExchangeRate",
      "kind": "LinkedField",
      "name": "rates",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "currencyID",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "code",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "symbol",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "rate",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "zeroDecimal",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "serviceCreditsQuery",
    "selections": [
      {
        "args": (v4/*: any*/),
        "kind": "FragmentSpread",
        "name": "serviceCreditsServiceCredit_fragment"
      },
      {
        "args": (v5/*: any*/),
        "kind": "FragmentSpread",
        "name": "serviceCreditsAddon_fragment"
      },
      (v6/*: any*/)
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "serviceCreditsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": "ServiceCredit",
        "kind": "LinkedField",
        "name": "serviceCredit",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "serviceCreditID",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "service",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "credit",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "autoRefill",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "unlimitedCredits",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "trialCreditsUsed",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasSellerPurchasedCredits",
            "storageKey": null
          },
          (v7/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v5/*: any*/),
        "concreteType": "Addon",
        "kind": "LinkedField",
        "name": "addon",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "addonID",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AddonRate",
            "kind": "LinkedField",
            "name": "rates",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "feeValue",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "usageFrom",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "rateID",
                "storageKey": null
              },
              (v7/*: any*/)
            ],
            "storageKey": null
          },
          (v7/*: any*/)
        ],
        "storageKey": null
      },
      (v6/*: any*/)
    ]
  },
  "params": {
    "cacheID": "257722a89fb35a39eb76bdb8060564a0",
    "id": null,
    "metadata": {},
    "name": "serviceCreditsQuery",
    "operationKind": "query",
    "text": "query serviceCreditsQuery(\n  $serviceName: ServicesWithCredits!\n  $addonKey: String!\n  $currencyCode: String!\n  $baseCurrencyCode: String!\n) {\n  ...serviceCreditsServiceCredit_fragment_4E6Gnr\n  ...serviceCreditsAddon_fragment_1OhAiz\n  exchangeRates(baseCurrencyCode: $baseCurrencyCode) {\n    baseCurrency\n    rates {\n      currencyID\n      code\n      symbol\n      rate\n      zeroDecimal\n    }\n  }\n}\n\nfragment serviceCreditsAddon_fragment_1OhAiz on Query {\n  addon(addonKey: $addonKey, currencyCode: $currencyCode) {\n    addonID\n    name\n    rates {\n      feeValue\n      usageFrom\n      rateID\n      id\n    }\n    id\n  }\n}\n\nfragment serviceCreditsServiceCredit_fragment_4E6Gnr on Query {\n  serviceCredit(serviceName: $serviceName) {\n    serviceCreditID\n    service\n    credit\n    autoRefill\n    unlimitedCredits\n    trialCreditsUsed\n    hasSellerPurchasedCredits\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "2c9f7dc9b28a6a77611abae138dcd935";

export default node;
